function PageHeader({ title, actions, children, onMenuClick }) {
  return (
    <header className="page-header">
      <div className="page-header-left">
        {onMenuClick && (
          <button
            className="btn btn-ghost mobile-menu-btn"
            onClick={onMenuClick}
            aria-label="Open menu"
          >
            ☰
          </button>
        )}
        <h1 className="page-title">{title}</h1>
      </div>
      {(actions || children) && (
        <div className="page-actions">
          {actions}
          {children}
        </div>
      )}
    </header>
  )
}

export default PageHeader
